import React, { useEffect, useState } from "react";
import { Alert, Col, Container, ListGroup, Row } from "react-bootstrap";
import { Eye } from "react-feather";
import { Helmet } from "react-helmet-async";
import toast from "react-hot-toast";

import { LoadingBox } from "../../components/Loader";
import ShipmentAccount from "./components/shipments/ShipmentAccount";
import DetermineShipmentLocationModal from "./components/shipments/ShipmentLocationModal";

import utilsService from "../../services/utils.service";

const ShipmentsPage = () => {
  const [initializing, setInitializing] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const [listingAccounts, setListingAccounts] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchListingAccounts = async () => {
      const result = await utilsService.getListingAccounts({
        amazonOnly: true,
      });

      if (!isMounted) return;

      if (result.success) {
        setListingAccounts(result.listingAccounts || []);
      } else {
        toast.error("Something went wrong. Please try again.");
      }

      setInitializing(false);
    };

    fetchListingAccounts();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      <Helmet title="Shipments" />
      <Container fluid className="p-0">
        <Row className="mb-2">
          <Col
            xxl={8}
            className="d-flex justify-content-between align-items-start"
          >
            <h1>Shipments</h1>
            {listingAccounts && (
              <DetermineShipmentLocationModal
                listingAccounts={listingAccounts}
                selectedAccount={selectedAccount}
              />
            )}
          </Col>
        </Row>
        {initializing ? (
          <LoadingBox />
        ) : (
          listingAccounts && (
            <>
              <Row className="mb-3">
                <Col xxl={8}>
                  <ListGroup horizontal>
                    {listingAccounts.map((account, index) => {
                      return (
                        <ListGroup.Item
                          tag="a"
                          key={index}
                          className="text-center"
                          onClick={() => setSelectedAccount(account)}
                          action
                          active={selectedAccount === account}
                          disabled={submitting}
                        >
                          {account.listingAccount}
                        </ListGroup.Item>
                      );
                    })}
                  </ListGroup>
                </Col>
              </Row>
              {selectedAccount ? (
                <ShipmentAccount
                  key={selectedAccount.listingAccountId}
                  submitting={submitting}
                  setSubmitting={setSubmitting}
                  selectedAccount={selectedAccount}
                />
              ) : (
                <Row>
                  <Col xxl={8}>
                    <Alert variant="primary">
                      <div className="alert-icon">
                        <Eye
                          className="position-relative top-50 start-50 translate-middle"
                          size={20}
                        />
                      </div>
                      <div className="alert-message">
                        Select an <strong>account</strong> to view shipments.
                      </div>
                    </Alert>
                  </Col>
                </Row>
                // )
              )}
            </>
          )
        )}
      </Container>
    </>
  );
};

export default ShipmentsPage;
